// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2lc3B","label":"Labeled_label__gOpDh","divider":"Labeled_divider__25Jnj"};